module.exports = "pegasus/assets/gray-large-twitter-old.png";